const CdKeyComponent = () => import('@/views/query/CdKey/CdKeyView')

export default [
    {
        path:'/CdKeyIndex',
        name:'CdKeyRouter',
        component:CdKeyComponent
    }
]